import { debitSchema } from '@billing/validation/debit';
import {
  Payor,
  EOB,
  Claim,
  Tariff,
  Provider,
  ClaimHistory,
  Submission,
  Remittance,
} from 'interfaces';

export interface DebitRemittanceLine {
  id: string;
  remittanceID: string;
  recordCode: string;
  claimNumber: string;
  serviceDate: string | null;
  tariffCode: string | null;
  prefix: number | null;
  services: number | null;
  feeSubmitted: string | number | null;
  amountAssessed: string | number;
  lineType: string;
  eobCodes: string[] | null;
  raw: string | null;
  createdAt: string;
  remittance?: Remittance | null;
}

export interface Debit {
  id: string;
  claimID: string;
  payorID: string;
  paidAmount: string | null;
  requestedAmount: string | null;
  adjustment?: string | null;
  microfilm: string | null;
  status: string | null;
  type: 'RETRACTION' | 'INFO' | 'PAYMENT' | null;
  source: 'REMITTANCE' | 'MANUAL' | null;
  createdAt: string;
  createdBy?: string | null;
  remittanceLineID?: string | null;
  remittanceLine?: DebitRemittanceLine | null;
  providerID: string;
  payor?: Payor;
  provider?: Provider;
  eobs?: EOB[];
  claim?: Claim;
  claimHistory?: ClaimHistory[];
  tariff?: Tariff;
  tariffID: string;
  submission?: Submission;
}

export type CreateDebit = Omit<Debit, 'id'>;

export interface PaginatedDebitResult {
  data: Debit[];
  nextPage: number;
  total: number;
}

export const isDebit = (obj: any): obj is Debit => {
  return debitSchema.safeParse(obj).success;
};
